import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import SearchBox from '@veeva/corgix/searchbox';

const HomeTitleDesktop = ({
    onChange,
    onClear,
    onSearch,
    searchPlaceholder,
    searchTerm,
    title,
}) => {
    return (
        <>
            {title}
            <div
                css={css`
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 0.6666rem;
                `}
            >
                <SearchBox
                    value={searchTerm}
                    onChange={onChange}
                    onSearch={onSearch}
                    onClear={onClear}
                    placeholder={searchPlaceholder}
                    size="lg"
                />
            </div>
        </>
    );
};

HomeTitleDesktop.propTypes = {
    onChange: PropTypes.func,
    onClear: PropTypes.func,
    onSearch: PropTypes.func,
    searchPlaceholder: PropTypes.string,
    searchTerm: PropTypes.string,
    title: PropTypes.element,
};

export default HomeTitleDesktop;
